import { supabase } from "@/integrations/supabase/client";
import { getConsentStatus } from "@/components/CookieConsent";

type EventType =
  | "page_view"
  | "signup"
  | "login"
  | "upload"
  | "like"
  | "comment"
  | "concert_added"
  | "profile_edit"
  | "search";

interface EventPayload {
  [key: string]: string | number | boolean | null;
}

const safeGetSessionStorage = (key: string): string | null => {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeSetSessionStorage = (key: string, value: string) => {
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    // ignore storage failures
  }
};

const makeId = () => {
  try {
    return crypto.randomUUID();
  } catch {
    return `sid_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }
};

const getSessionId = (): string => {
  const key = "encore-session-id";
  const existing = safeGetSessionStorage(key);
  if (existing) return existing;
  const id = makeId();
  safeSetSessionStorage(key, id);
  return id;
};

export const trackEvent = async (
  eventType: EventType,
  payload: EventPayload = {}
) => {
  // Only track if user accepted cookies
  if (getConsentStatus() !== "accepted") return;

  try {
    await (supabase as any).from("analytics_events").insert({
      event_type: eventType,
      session_id: getSessionId(),
      page_url: window.location.pathname,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      payload,
    });
  } catch {
    // silent fail by design
  }
};

export const trackPageView = () => {
  void trackEvent("page_view", { path: window.location.pathname });
};
